export default __webpack_public_path__ + "static/media/brush.227e2eab.svg";